import { useEffect } from "react";

import { brandName } from "@/lib/branding";

/** Sets `document.title` to "<title> · <product name>" (or the tenant's name) while the calling page is mounted. */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} · ${brandName()}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
